/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
// gatsby-browser.js

import Clarity from '@microsoft/clarity';

export const onInitialClientRender = () => {
  try {
    Clarity.init('sccfeybu5t');
  } catch (error) {
    console.error('Clarity initialization failed:', error);
  };
}

export const onClientEntry = () => {
  (function (h, i, v, e, s, d, k) {
    h.HiveSDKObject = s;
    h[s] = h[s] || function () {
      // eslint-disable-next-line no-sequences
      (h[s].q = h[s].q || []).push(arguments)
    }, d = i.createElement(v), k = i.getElementsByTagName(v)[0];
    d.async = 1; d.id = s; d.src = e + '?sef=1&r=' + parseInt(new Date() / 60000);
    k.parentNode.insertBefore(d, k);
  })(window, document, 'script', 'https://cdn-prod.hive.co/static/js/sdk-loader.js', 'HIVE_SDK');

  // Lucky Orange script loader
  const loScript = document.createElement('script');
  loScript.src = 'https://tools.luckyorange.com/core/lo.js?site-id=99a00b9d';
  loScript.async = true;
  loScript.defer = true;
  document.head.appendChild(loScript);


  window.onload = () => {
    if (window.HIVE_SDK && typeof window.HIVE_SDK === 'function') {
      window.HIVE_SDK('init', 132005);
    }
  };
}

